// extracted by mini-css-extract-plugin
export default {"about":"index_about_1p8sZ","summary":"index_summary_J87xj","more":"index_more_vziZf"};